import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Modal, Button } from 'react-bootstrap';
import Swal from 'sweetalert2';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.min.css';

import { useNavigate,Link } from 'react-router-dom';
import { globalErrorHandler } from '../../../utils/GlobalErrorHandler';
import { formatDate } from '../../../utils/dateUtils';


const Guest = () => {
    const navigate = useNavigate();
    const debounceTimeout = useRef(null);
    const [guests, setGuests] = useState([]);
    const [properties, setProperties] = useState([]);
    const [floors, setFloors] = useState([]);
    const [rooms, setRooms] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [pagination, setPagination] = useState({ page: 1, limit: 10, total: 0, totalPages: 1 });
    const [showJobModal, setShowJobModal] = useState(false);
    const [jobDate, setJobDate] = useState(null);
    const [selectedGuestId, setSelectedGuestId] = useState(null);
    const [showPhaseModal, setShowPhaseModal] = useState(false);
    const [selectedPhase, setSelectedPhase] = useState('');
    const [phases, setPhases] = useState([]);
    const [filter, setFilter] = useState({
        guest_name: '',
        property_id: '',
        floor_id: '',
        room_id: '',
    });
const [showMoveOutModal, setShowMoveOutModal] = useState(false);
const [moveOutNotes, setMoveOutNotes] = useState('');
const [showNotesModal, setShowNotesModal] = useState(false);
const [guestNotes, setGuestNotes] = useState('');

useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


    const getPhases = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-phases`, {
                withCredentials: true,
            });
            if (res.data.status) {
                setPhases(res.data.phases || []);
            }
        } catch (error) {
            globalErrorHandler(error, navigate);
        }
    };
    const getPreviousGuests = async () => {
        setIsLoading(true);
        try {
            const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-previous-guests`, {
                params: {
                    page: pagination.page,
                    limit: pagination.limit,
                    guest_name: filter.guest_name,
                    property_id: filter.property_id,
                    floor_id: filter.floor_id,
                    room_id: filter.room_id,
                },
                withCredentials: true
            });

            if (res.data.status) {
                setGuests(res.data.guests || []);
                setPagination(res.data.pagination);
            } else {
                setGuests([]);
            }
        } catch (error) {
            globalErrorHandler(error, navigate);
        } finally {
            setIsLoading(false);
        }
    };


      const getGuests = async () => {
        setIsLoading(true);
        try {
            const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-current-guests`, {
                params: {
                    page: pagination.page,
                    limit: pagination.limit,
                    guest_name: filter.guest_name,
                    property_id: filter.property_id,
                    floor_id: filter.floor_id,
                    room_id: filter.room_id,
                },
                withCredentials: true
            });

            if (res.data.status) {
                setGuests(res.data.guests || []);
                setPagination(res.data.pagination);
            } else {
                setGuests([]);
            }
        } catch (error) {
            globalErrorHandler(error, navigate);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getProperties();
        getFloors();
        getRooms();
        getPhases();
    }, []);

    useEffect(() => {
        if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(() => {
            getGuests();
        }, 500);
        return () => clearTimeout(debounceTimeout.current);
    }, [pagination.page, filter]);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilter(prev => {
            const updated = { ...prev, [name]: value };
            if (name === "property_id") {
                updated.floor_id = "";
                updated.room_id = "";
                setFloors([]);
                setRooms([]);
                getFloors(value);
            } else if (name === "floor_id") {
                updated.room_id = "";
                setRooms([]);
                getRooms(value);
            }
            return updated;
        });

        setPagination(prev => ({ ...prev, page: 1 }));

    };

    const updateJobDueDate = async () => {
        try {
            await axios.post(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/update-job-due-date`, {
                guest_id: selectedGuestId,
                job_due_date: jobDate,
            }, { withCredentials: true });
            Swal.fire('Success', 'Job due date updated.', 'success');
            setShowJobModal(false);
            getGuests();
        } catch (error) {
            globalErrorHandler(error, navigate);
        }
    };

    const updateGuestPhase = async () => {
        await axios.post(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/update-guest-phase`, {
            guest_id: selectedGuestId,
            phase_id: selectedPhase,
        }, { withCredentials: true });

        setShowPhaseModal(false);
        setSelectedGuestId(null);
        setSelectedPhase('');
        getGuests(); // refresh list
    };
    const clearFilter = () => {
        setFilter({ guest_name: '', property_id: '', floor_id: '', room_id: '' });
        setPagination(prev => ({ ...prev, page: 1 }));
    };

    const getProperties = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-properties`, { withCredentials: true });
            if (res.data.status) {
                setProperties(res.data.properties || []);
            }
        } catch (error) {
            globalErrorHandler(error, navigate);
        }
    };

    const getFloors = async (propertyId) => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-floors?property_id=${propertyId}`, { withCredentials: true });
            if (res.data.status) {
                setFloors(res.data.floors || []);
            }
        } catch (error) {
            globalErrorHandler(error, navigate);
        }
    };

    const getRooms = async (floorId) => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-rooms?floor_id=${floorId}`, { withCredentials: true });
            if (res.data.status) {
                setRooms(res.data.rooms || []);
            }
        } catch (error) {
            globalErrorHandler(error, navigate);
        }
    };



// Fetch guest notes when opening modal
const fetchGuestNotes = async (guestId) => {
  setIsLoading(true);
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-guest-notes`,
      {
        params: { guest_id: guestId },
        withCredentials: true,
      }
    );
    if (res.data.status) {
      setGuestNotes(res.data.notes || '');
    } else {
      setGuestNotes('');
    }
  } catch (error) {
    globalErrorHandler(error, navigate);
  } finally {
    setIsLoading(false);
  }
};

// Save guest notes
const saveGuestNotes = async () => {
  try {
    setIsLoading(true);
    await axios.post(
      `${process.env.REACT_APP_WEB_SERVICES_URL}/admin/save-guest-notes`,
      {
        guest_id: selectedGuestId,
        notes: guestNotes,
      },
      { withCredentials: true }
    );
    Swal.fire('Success', 'Notes saved successfully.', 'success');
    setShowNotesModal(false);
    setSelectedGuestId(null);
    setGuestNotes('');
  } catch (error) {
    globalErrorHandler(error, navigate);
  } finally {
    setIsLoading(false);
  }
};
    return (
        <div className="container-fluid px-4 mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3>Manage Guests</h3>
            </div>

            <div className="d-flex align-items-center mb-3">
                <Button variant="dark" type="button"  onClick={() => navigate('/admin/guest-management/guest')} className="rounded-pill me-2" >Current</Button>
                <Button variant="outline-dark" type="button"  onClick={() => navigate('/admin/guest-management/guest-previous')} className="rounded-pill" >Previous</Button>
            </div>

            <div className="card shadow mt-4">
                <div className="card-header">
                    <h5 className="mb-0">Search Guests</h5>
                </div>
                <div className="card-body p-4">
                    {/* Filter Section */}
                    <div className="row align-items-end g-2 mb-4">
                        <div className="col-md-3">
                            <div className="position-relative">
                                <input
                                    type="text"
                                    className="form-control ps-3 pe-5 rounded-3"
                                    placeholder="Search Guest"
                                    name="guest_name"
                                    value={filter.guest_name || ''}
                                    onChange={handleFilterChange}
                                />
                                <i
                                    className="bi bi-search position-absolute top-50 end-0 translate-middle-y me-3 text-muted"
                                    style={{ pointerEvents: 'none' }}
                                ></i>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <select
                                className="form-select rounded-3"
                                name="property_id"
                                value={filter.property_id}
                                onChange={handleFilterChange}
                            >
                                <option value="">Select Property</option>
                                {properties.map(p => (
                                    <option key={p.id} value={p.id}>{p.property_name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-3">
                            <select
                                className="form-select rounded-3"
                                name="floor_id"
                                value={filter.floor_id}
                                onChange={handleFilterChange}
                            >
                                <option value="">Select Floor</option>
                                {floors.map(f => (
                                    <option key={f.id} value={f.id}>{f.floor_name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-2">
                            <select
                                className="form-select rounded-3"
                                name="room_id"
                                value={filter.room_id}
                                onChange={handleFilterChange}
                            >
                                <option value="">Select Room</option>
                                {rooms.map(r => (
                                    <option key={r.id} value={r.id}>{r.room_no}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-1 d-flex">
                            <button type="button" className="btn btn-dark w-100 rounded-3" onClick={clearFilter}>
                                Clear
                            </button>
                        </div>
                    </div>

                    {/* Guest Table */}

                    <div className="table-responsive">
                        <table className="table table-bordered table-hover shadow-sm nowrap">
                            <thead className="table-success">
                                <tr>
                                    <th>Guest ID</th>
                                    <th>Name</th>
                                    <th>Contact Info</th>
                                    <th>Phase</th>
                                    <th>Bed</th>
                                    <th>Floor</th>
                                    <th>Property</th>
                                    <th>Unit Rate</th>
                                    <th>Move-in Date</th>
                                    <th>Job Due Date</th>
                                    <th>PO Information</th>
                                    <th>Documents</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr><td colSpan="11">Loading...</td></tr>
                                ) : guests.length === 0 ? (
                                    <tr><td colSpan="11">No data found.</td></tr>
                                ) : (
                                    guests.map(g => (
                                        <tr key={g.id}>
                                            <td>{`BBM${String(g.id).padStart(4, '0')}`}</td>
                                            <td>{g.name}</td>
                                            <td>{`${g.phone ? g.phone + ' ' : ''}${g.email}`}</td>
                                            <td>{g.phase_title}</td>
                                            <td>{g.bedtype}</td>
                                            <td>{g.floor_name}</td>
                                            <td>{g.property_name}</td>
                                            <td>{Number.isFinite(Number(g.monthly_rate)) ? `$${Number(g.monthly_rate).toFixed(2)}` : ''}</td>
                                            <td>{formatDate(g.move_in_date)}</td>
                                            <td>{formatDate(g.job_due_date)}</td>
                                             <td>{g.officer_name}, {g.officer_phone}</td>
                                            <td style={{ 'width': "180px" }}>
                                                   <Link to={`/admin/guest-management/sign-consent/${g.id}`} className="btn btn-success btn-sm me-1"   >Sign Consent</Link>
 {!g.move_in_date ?
 <Button disabled={true} variant="warning" className="btn-sm me-1"  >Lease Agreement</Button>
:
  <a href={`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/lease-agreement/${g.id}`}  target="_blank" rel="noopener noreferrer" className="btn btn-warning btn-sm me-1" >Lease Agreement</a>
 }
                                           {/* <Button variant="info" className="btn-sm" onClick="#">Email History</Button> */}     
                                            </td>
                                            <td style={{ 'width': "400px" }}>
                                                <a className="btn btn-success btn-sm me-1" href={`/admin/guest-management/guest-intake-form-view/${g.id}`}>View</a>
                                                <a className="btn btn-info btn-sm me-1" href={`/admin/guest-management/guest-intake-form/${g.id}`}>Edit</a>
                                                <Button disabled={!g.move_in_date} variant="danger" className="btn-sm me-1" onClick={() => { setSelectedGuestId(g.id);setMoveOutNotes('');setShowMoveOutModal(true); }} >Move Out</Button>
                                                <Button variant="primary" className="btn-sm me-1" onClick={() => { setSelectedGuestId(g.id); setSelectedPhase(g.phase_id); setShowPhaseModal(true); }}>Phases</Button>
                                                <Button variant="warning" className="btn-sm me-1" onClick={() => { setSelectedGuestId(g.id); setShowJobModal(true); }}>Job Due Date</Button>
                                                <Button variant="dark"   className="btn-sm me-1"   onClick={() => {   setSelectedGuestId(g.id); setShowNotesModal(true);     fetchGuestNotes(g.id);  }} >Notes</Button>
                                                <a className="btn btn-primary btn-sm me-1" href={`/admin/guest-management/guest-location/${g.id}`}>Locations</a>
                                         
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                    {/* Pagination */}
                    <div className="d-flex justify-content-end mt-3">
                        <nav>
                            <ul className="pagination">
                                {[...Array(pagination.totalPages)].map((_, i) => (
                                    <li key={i} className={`page-item ${pagination.page === i + 1 ? 'active' : ''}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => setPagination(prev => ({ ...prev, page: i + 1 }))}
                                        >
                                            {i + 1}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>

            <Modal show={showJobModal} onHide={() => setShowJobModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Job Due Date</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <label className="form-label">Select Date</label>
                    <Flatpickr className="form-control" value={jobDate} onChange={date => setJobDate(date[0])} options={{ dateFormat: "Y-m-d", altInput: true, altFormat: "m/d/Y" }} placeholder="Select Job Due Date" />

                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-dark w-100" onClick={() => { updateJobDueDate(); setShowJobModal(false); setSelectedGuestId(null); }}>Save</button>

                </Modal.Footer>
            </Modal>

            <Modal show={showPhaseModal} onHide={() => setShowPhaseModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Select Phase</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label className="form-label">Select Phase</label>
                        <select className="form-select" value={selectedPhase} onChange={(e) => setSelectedPhase(e.target.value)}   >
                            <option value="">-- Select Phase --</option>
                            {phases.map(p => (
                                <option key={p.id} value={p.id}>{p.title}</option>
                            ))}
                        </select>
                    </div>
                    <button className="btn btn-dark w-100" onClick={updateGuestPhase}  >Save</button>
                </Modal.Body>
            </Modal>

            <Modal show={showMoveOutModal} onHide={() => setShowMoveOutModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Move Out Notes</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div className="mb-3">
      <label className="form-label">Move Out Notes</label>
      <textarea
        className="form-control"
        rows="4"
        value={moveOutNotes}
        onChange={(e) => setMoveOutNotes(e.target.value)}
        placeholder="Enter any notes for this guest's move-out..."
      ></textarea>
    </div>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowMoveOutModal(false)}>
      Cancel
    </Button>
    <Button
      variant="danger"
      onClick={async () => {
        try {
          await axios.post(
            `${process.env.REACT_APP_WEB_SERVICES_URL}/admin/move-out-guest`,
            {
              guest_id: selectedGuestId,
              notes: moveOutNotes,
            },
            { withCredentials: true }
          );
          Swal.fire('Success', 'Guest moved out successfully.', 'success');
          setShowMoveOutModal(false);
          setSelectedGuestId(null);
          getGuests();
        } catch (error) {
          globalErrorHandler(error, navigate);
        }
      }}
    >
      Confirm Move Out
    </Button>
  </Modal.Footer>
</Modal>


<Modal show={showNotesModal} onHide={() => setShowNotesModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Guest Notes</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {isLoading ? (
      <p>Loading notes...</p>
    ) : (
      <textarea
        className="form-control"
        rows="5"
        value={guestNotes}
        onChange={(e) => setGuestNotes(e.target.value)}
        placeholder="Enter notes for this guest..."
      ></textarea>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowNotesModal(false)}>
      Cancel
    </Button>
    <Button variant="dark" onClick={saveGuestNotes}>
      Save Notes
    </Button>
  </Modal.Footer>
</Modal>


        </div>
    );
};

export default Guest;
